import { render, staticRenderFns } from "./WikipediaTableForm.vue?vue&type=template&id=46fc1ba4&"
import script from "./WikipediaTableForm.vue?vue&type=script&lang=js&"
export * from "./WikipediaTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports